var _circle, _circle2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 46,
    fill: "#EAB308",
    stroke: "#1D4ED8",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 33,
    fill: "#F8FAFC",
    stroke: "#1D4ED8",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 46,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Arial",
    fontSize: 16,
    fontWeight: 700,
    fill: "#0F172A"
  }, "ISO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 62,
    textAnchor: "middle",
    fontFamily: "Segoe UI, Arial",
    fontSize: 10,
    fontWeight: 700,
    fill: "#1D4ED8"
  }, "CERTIFIED")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIso);
export default __webpack_public_path__ + "static/media/iso.a42f32ac8f6236e1c4d1053a69fce483.svg";
export { ForwardRef as ReactComponent };